import mixpanel from 'mixpanel-browser';
import { BUTTON_CLICK, ERROR_OCCURED, FAILURE, LOGIN_ERROR_IDENTIFICATION, LOGIN_OUTCOME, N_A, SUCCESS, TAB_VIEW } from '../../constants/mixPannelConstants';

export const errorOccuredAndLogged_Mixpanel = (error, context, errorType) => {
  mixpanel.track(ERROR_OCCURED, {
    //error: error,
	context: context || ERROR_OCCURED,
	ErrorCode: error?.code || '',
	ErrorResponse: error?.response?.data?.message || '',
	ErrorType: errorType || ERROR_OCCURED,
	PagePath: window.location.pathname || '',
	StatusCode: error?.response?.status || '',
    StatusText: error?.response?.statusText || '',
    EventTime: new Date().toUTCString()
  });
};

export const buttonClick_Mixpanel = (buttonName) => {
	mixpanel.track(BUTTON_CLICK, {
		buttonName: buttonName,
		EventTime: new Date().toUTCString(),
		PageName: N_A,
		timeSpent: N_A
	});
};

export const loginOutcome_Mixpanel = (outcome) => {
	mixpanel.track(LOGIN_OUTCOME, {
		EventTime: new Date().toUTCString(),
		PageName: N_A,
		buttonName: N_A,
		timeSpent: N_A,
		outcome: outcome
	});
};

export const loginErrorIdentification_Mixpanel = (errorMessage) => {
	mixpanel.track(LOGIN_ERROR_IDENTIFICATION, {
		errorMessage: errorMessage || 'Unknown error',
		EventTime: new Date().toUTCString(),
		PageName: N_A,
		buttonName: N_A,
		timeSpent: N_A,
		outcome: FAILURE
	});
};

export const trackTabView_Mixpanel = (tabName, pageName) => {
	mixpanel.track(TAB_VIEW, {
		tabViewed: tabName,
		EventTime: new Date().toUTCString(),
		buttonName: N_A,
		timeSpent: N_A,
		PageName: pageName,
		outcome: N_A
	});
};
